import { Marked, type Token } from 'marked';

const lexer = new Marked({ gfm: true });
const normalize = (text: string) => text.normalize('NFC').replace(/\s+/g, ' ').trim();

function headingText(token: Token): string {
  if ('tokens' in token && token.tokens) return token.tokens.map(headingText).join('');
  return 'text' in token ? token.text : '';
}

/** Remove only a contiguous leading sequence of headings already named by the
 * breadcrumb. Parse block tokens so fenced code, setext headings and body text
 * keep their syntax. Stop at the first unmatched heading or content block.
 */
export function stripKnowledgeBreadcrumbHeadings(
  content: string,
  sectionPath?: string | null,
  documentTitle?: string | null,
): string {
  if (!sectionPath) return content;
  const path = [documentTitle ?? '', ...sectionPath.split(/\s+>\s+/)].map(normalize).filter(Boolean);
  let nextPathIndex = 0;
  let offset = 0;
  let cut = 0;
  let matched = false;
  const normalizedSource = content.replace(/\r\n?/g, '\n');
  for (const token of lexer.lexer(normalizedSource)) {
    offset += token.raw.length;
    if (token.type === 'space') {
      if (matched) cut = offset;
      continue;
    }
    if (token.type !== 'heading') break;
    const title = normalize(headingText(token));
    const index = path.findIndex((part, i) => i >= nextPathIndex && part === title);
    if (index < 0) break;
    nextPathIndex = index + 1;
    matched = true;
    cut = offset;
  }
  return matched ? normalizedSource.slice(cut) : content;
}

/** IDs stay in the data model for navigation; an opaque ID is never a label. */
export function knowledgeRepositoryLabel(label?: string | null): string | undefined {
  const text = label?.trim();
  return text && !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(text)
    ? text : undefined;
}
